import React, { useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useSelector } from "react-redux";
import { ChangeAdminPassword } from "../utils/Api/ApiCalls";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";

const schema = yup.object().shape({
	password: yup.string().required("this field is required"),
	confirmPassword: yup
		.string()
		.oneOf([yup.ref("password")], "this field is required"),
});

const EditAccount = () => {
    const Navigate = useNavigate();
	const currentUser = useRecoilValue(userState)

	const {
		handleSubmit,
		formState: { errors },
		register,
	} = useForm({
		resolver: yupResolver(schema),
	});

  const [load, setLoad] = useState(false)

	const onChangePassword = handleSubmit(async (data) => {
		const { password } = data;
  setLoad(true)

		try {
			const response = await ChangeAdminPassword(currentUser?.data?.info?.id, {
				password,
			});

       Swal.fire({
					icon: "success",
					title: `${response.message}`,
					timer: 2000,
					showConfirmButton: false,
				}).then(() => {
					Navigate("/admin-dashboard");
				});

      setLoad(false)

			
		} catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
	});

	const [showResetP, setSetShowResetP] = useState(false);

	const toggleResetPassword = () => {
		setSetShowResetP(!showResetP);
	};
	return (
		<div class='col-lg-9'>
							<section class='content-body p-xl-4'>
								{/* <hr class='my-5' /> */}
								<div
									class='row'
									style={{
										maxWidth: "920px",
									}}>
									<div class='col-md'>
										<article class='box mb-3 bg-light'>
											<a
												onClick={toggleResetPassword}
												class='btn float-end btn-light btn-sm rounded font-md'
												href='#'>
												Change
											</a>
											<h6>Password</h6>
											<small
												class='text-muted d-block'
												style={{
													width: " 70%",
												}}>
												You can reset or change your password by clicking here
											</small>
										</article>
									</div>

									<div class='col-md'>
										<article class='box mb-3 bg-light'>
											<a
												class='btn float-end btn-light rounded btn-sm font-md'
												href='#'>
												Deactivate
											</a>
											<h6>Remove account</h6>
											<small
												class='text-muted d-block'
												style={{
													width: " 70%",
												}}>
												Once you delete your account, there is no going back.
											</small>
										</article>
									</div>
									{showResetP && (
										<>
											<h4>Change Password</h4>
											<br />
											<br />
											<form onSubmit={onChangePassword}>
												<div class='col-lg-12 mb-3'>
													<label class='form-label'>New Password</label>
													<input
														{...register("password")}
														class='form-control'
														type='password'
														placeholder='Type here'
													/>
												</div>
												<div class='col-lg-12 mb-3'>
													<label class='form-label'>Confirm New Password</label>
													<input
														{...register("confirmPassword")}
														class='form-control'
														type='password'
														placeholder='Type here'
													/>
												</div>
												{load ? (
													<button
														disabled
														style={{
															background: "silver",
														}}
														class='btn btn-primary'
														type='submit'>
														Loading...
													</button>
												) : (
													<button class='btn btn-primary' type='submit'>
														Save changes
													</button>
												)}
											</form>
										</>
									)}
								</div>
							</section>
						</div>
	);
};

export default EditAccount;
